export enum DexieErrorEnum {
  DATABASE_CLOSED_ERROR = 'DatabaseClosedError',
  DATA_ERROR = 'DataError',
  DATA_CLONE_ERROR = 'DataCloneError',
  INVALID_STATE_ERROR = 'InvalidStateError',
  ABORT_ERROR = 'AbortError',
  TRANSACTION_INACTIVE_ERROR = 'TransactionInactiveError'
}
